export const acCategoryTypes = {
    loading: "LOADING_ACCATEGORY",
    delete: "DELETE_ACCATEGORY",
    loadedOne: "LOADED_ACCATEGORY",
    loadedMultiple: "LOADED_ACCATEGORYS",
    success: "SUCCESS_ACCATEGORY",
    restore: "RESTORE_ACCATEGORY",
    hardDelete: "HARDDELETE_ACCATEGORY",
};
